import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyCjEEOnrCUBRZNPozDVvcMbgxM46sehbP0",
  authDomain: "seating-plan-app.firebaseapp.com",
  projectId: "seating-plan-app",
  storageBucket: "seating-plan-app.firebasestorage.app",
  messagingSenderId: "301805156400",
  appId: "1:301805156400:web:d4c5b50477df5f51bf95f5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
